import * as React from "react";

import { cn } from "./utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
	return (
		<textarea
			data-slot="textarea"
			className={cn(
				"resize-none border-input placeholder:text-placeholder flex min-h-24 w-full rounded-md border bg-input-background px-3 py-2 text-base font-semibold transition-[border-color,box-shadow,background-color] outline-none hover:bg-input-hover focus-visible:border-ring focus-visible:bg-field-focus focus-visible:ring-ring/25 focus-visible:ring-[3px] aria-invalid:border-destructive aria-invalid:ring-danger-tint disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground disabled:opacity-100 md:text-sm",
				className,
			)}
			{...props}
		/>
	);
}

export { Textarea };
